import React, { FC }  from 'react';
import { usePermissionCheck } from '../../hooks/permissions/usePermissionCheck';
import { Claims } from '../../types/permissions/Claims';

interface Props {
    permissions: readonly Claims[]
}

const Permissive: FC<Props> = ({ permissions, children }) => {
    const userHasPermission = usePermissionCheck(permissions);

    return (
        <>
            {userHasPermission && children}
        </>
    );    
};

export default Permissive;